import { Screen } from '@bonanza-social/navigation';
import { CommunityJackpotWinnersScreenProps } from './CommunityJackpotWinnersScreen.types';
import CommunityJackpotWinners from '../../components/CommunityJackpotWinners/CommunityJackpotWinners';

function CommunityJackpotWinnersScreen({
  route,
}: CommunityJackpotWinnersScreenProps) {
  const { milestoneId } = route.params;

  return (
    <Screen paddingHorizontal="-space-0">
      <CommunityJackpotWinners milestoneId={milestoneId} />
    </Screen>
  );
}

export default CommunityJackpotWinnersScreen;
